import React from 'react'
import WineLocationRouter from '../StoreLayouts/WineLayouts/WineLocationRouter'

class Wine extends React.Component {
    constructor(props){
        super(props)
        this.state = {
            whiteWineMenu: '',
            redWineMenu: ''
        }
    }
    getWineMenu = (wineMenuId, location) => {
        const url = `https://pl-api-dev.herokuapp.com/api/untappd/menu/${wineMenuId}`
        return fetch(url)
        .then(res => res.json())
        .then(data => {
            console.log(data)
        
            let whiteWine = data.menu.sections.filter(section => section.name === "White Wine")
            let redWine = data.menu.sections.filter(section => section.name === "Red Wine")
              
            let wine = {
                whiteWine: whiteWine[0].items,
                redWine: redWine[0].items
            }
            return wine
        })
        .then(wine => this.setState({whiteWineMenu: wine.whiteWine, redWineMenu: wine.redWine, location: location}))
        .catch(err => err)
    }
    filterPrice = (price) => {
       let priceNum = parseFloat(price)
       if (priceNum - Math.floor(priceNum) === 0){
           return parseInt(price)
       } else if (priceNum - Math.floor(priceNum) !== 0){
           return price
       }
    }
    filterPriceName = (priceName) => {

        // need to filter our by glass or bottle and rebuild array in the correct order (glass then bottle)
        if (priceName.includes("split")){
            return priceName
        }
    }
    orderWinePrices = (winePriceArray) => {
        console.log(winePriceArray)
        
    }
    componentDidMount(){
        const wineMenuId = this.props.match.params.wineMenuId
        const location = this.props.match.params.location

        this.getWineMenu(wineMenuId, location)
    }
    render(){

        return(
            <WineLocationRouter 
                location={this.state.location}
                whiteWineMenu={this.state.whiteWineMenu}
                redWineMenu={this.state.redWineMenu}
                filterPrice={this.filterPrice}
                filterPriceName={this.filterPriceName}
                orderWinePrices={this.orderWinePrices}
            />
        )
    }
}
export default Wine




/*
pl1 - none
pl2 - none
pl3 - white, red
pl4 - none
pl5 - none
pl6 - white, red
pl7 - white, red
pl8 - white, red
pl9 - white, red


*/